import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useMap } from 'react-leaflet';
import {
  isFullscreenAvailable,
  requestFullscreen,
  exitFullscreen,
} from '@/utils';

import {
  useAppSelector,
  isEmbeddedSelector,
  mapUrlSelector,
  preferencesSelector,
} from '@/store';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowsMinimize,
  faArrowsMaximize,
} from '@fortawesome/pro-regular-svg-icons';

export function Maximize() {

  const map = useMap();
  const [isFullscreen, setIsFullscreen] = useState(false);

  const isEmbedded = useAppSelector(isEmbeddedSelector)
    || window.location !== window.parent.location;
  const mapUrl = useAppSelector(mapUrlSelector);
  const preferences = useAppSelector(preferencesSelector);
  const corner = preferences.sidebarPosition === 'right' ? 'topleft' : 'topright';

  const maximize = () => {
    if (isEmbedded) {
      window?.open(mapUrl, '_blank', 'noreferrer')?.focus();
      return;
    }
    const visrezDiv = document.getElementById('visrez-interactive')!;

    isFullscreen ? exitFullscreen() : requestFullscreen(visrezDiv);
  };

  useEffect(() => {
    const exitHandler = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', exitHandler);
    return () => document.removeEventListener('fullscreenchange', exitHandler);
  }, []);

  if (!isEmbedded && !isFullscreenAvailable()) {
    return null;
  }

  return createPortal(
    <div
      className="leaflet-bar leaflet-control"
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}

    >
      <div className="map-controls">
        <a
          href="#0"
          role="button"
          className="button maximize"
          onClick={(e) => {
            maximize();
            e.preventDefault();
          }}
        >
          <FontAwesomeIcon icon={isFullscreen ? faArrowsMinimize : faArrowsMaximize} />
        </a>
      </div>
    </div>,
    // @ts-ignore
    map._controlCorners[corner]
  );
}
